import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSuburbanData } from './fetchSuburbanData';
import { IThunkApi } from '../../types/redux';
import { selectEstimationTarget, selectSource, selectSuburbanFormValues } from '../../selectors';

import { mapEstimationTargetToECategory } from './mappers';
import { IApplicationContext } from '../../types/applicationContext';
import { setErrorMessage, setRedirectUrl } from '../../slices';

export const submitSuburbanData = createAsyncThunk<void, undefined, IThunkApi>(
  'form/submitSuburbanData',
  async (_, _thunkApi) => {
    const { extra, getState, dispatch } = _thunkApi;

    const state = getState();
    const estimationTarget = selectEstimationTarget(state);

    const { address, landArea, houseArea } = selectSuburbanFormValues(state);
    const source = selectSource(state);

    const parameters = {
      address,
      landArea: landArea as number,
      houseArea,
      category: mapEstimationTargetToECategory[estimationTarget],
      isNeedPushSubscribe: false,
      source,
    };

    try {
      const res = await fetchSuburbanData(parameters, extra as IApplicationContext);

      dispatch(setRedirectUrl(res));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    }
  },
);
